//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bus from '@/utils/bus';
export default {
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      rules: {
        refundDate: [{
          required: true,
          message: '请选择退租日期',
          trigger: 'change'
        }]
      },
      dates: [],
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });
      this.childData = this.keyValue;
      this.$set(this.childData, 'dates', [this.childData.beginDate, this.childData.endDate]);
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this2.$emit('handCancle', 'rentAgreement');

          setTimeout(function () {
            bus.$emit('returnRent', _this2.childData);
          }, 1000);
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};